export enum CredentialKind {
    PERSONAL = 'PERSONAL', ORGANIZATIONAL = 'ORGANIZATIONAL', PRODUCT = 'PRODUCT', UNKNOWN = 'UNKNOWN'
}
